import { CustomPage } from '@/components';
import Layout from '@/components/Layout';
import { OTElementId } from '@/constants';
import settingsSlice, { tabSelectedSelector } from '@/redux/features/settings.slice';
import contextualBarSlice, { isShowContextualBarSelector } from '@/redux/features/contextualBar.slice';
import useHandleContextureBar from '@/hooks/useHandleContextureBar';
import { Modal } from '@shopify/polaris';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tabsConfig } from './config';

const SETTINGS_SAVE_BAR_IDS = [OTElementId.SaveBar, OTElementId.SaveBarCourierSettings];

const Settings = () => {
  const dispatch = useDispatch();
  const persistedTab = useSelector(tabSelectedSelector);
  const tabSelected = tabsConfig.some((tab) => tab.value === persistedTab) ? persistedTab : tabsConfig[0].value;
  const isShowContextualBar = useSelector(isShowContextualBarSelector);
  const { hide } = useHandleContextureBar();
  const [pendingTab, setPendingTab] = useState<string | null>(null);

  const handleSelected = (value: Array<string>) => {
    if (isShowContextualBar) {
      setPendingTab(value[0]);
      return;
    }
    dispatch(settingsSlice.actions.handleSelected(value[0]));
  };

  const handleLeave = () => {
    SETTINGS_SAVE_BAR_IDS.forEach((id) => hide(id));
    if (pendingTab) dispatch(settingsSlice.actions.handleSelected(pendingTab));
    dispatch(contextualBarSlice.actions.handleUpdateContextualBarState({ isShowContextualBar: false }));
    setPendingTab(null);
  };

  return (
    <Layout title="Settings">
      <CustomPage tabsConfig={tabsConfig} selected={[tabSelected]} onChange={handleSelected} selectedTab={tabSelected} />
      <Modal
        title="You have unsaved changes"
        open={!!pendingTab}
        onClose={() => setPendingTab(null)}
        primaryAction={{
          content: 'Leave page',
          onAction: handleLeave,
          // @ts-ignore — Polaris ComplexAction accepts tone for destructive actions
          tone: 'critical',
        }}
        secondaryActions={[{ content: 'Cancel', onAction: () => setPendingTab(null) }]}
      >
        <Modal.Section>If you leave this page, all unsaved changes will be lost.</Modal.Section>
      </Modal>
    </Layout>
  );
};

export default Settings;
